import { useReadSurveyFactory } from './useReadSurveyFactoryContract'
import { Hex } from 'viem'

export function useIsAdmin(address: `0x${string}`) {
	return useReadSurveyFactory({
		functionName: 'hasRole',
		args: ['0x05477c39c14a8a45f68e248e875c7b89913df266bcc8ea9804f3160438f36dfd' as Hex, address as Hex] // POLL_ADMIN_ROLE = 0x05477c39c14a8a45f68e248e875c7b89913df266bcc8ea9804f3160438f36dfd
	})
}
